module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "contents",
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "h2",
    attrs: {
      "id": "contents"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page xiv. ",
      "epub:type": "pagebreak",
      "id": "page_xiv",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('b', [_vm._v("Part One: Who Am I?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_vm._v("1. The Nameless Uncarved Wood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_vm._v("2. The Original AI: Animate Intelligence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Most Important Relationship in Your Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Two: Where Am I?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Patterns of the Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Harmonic Dance of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Three: What Am I?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. The Deep Purpose of Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Tao in My Own Nature")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Four: How Should I Live?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Flourishing as an Integrated Organism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Cultivating Integrated Values")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Human/Nature")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Five: Why Am I?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Everything Is Connected")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. From Fixed Self to Infinite Li: The Fractal Nature of Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Six: Where Are We Going?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Weaving a New Story of Meaning")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Glossary")])]), _c('span', {
    attrs: {
      "aria-label": " Page xv. ",
      "epub:type": "pagebreak",
      "id": "page_xv",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Permissions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About New Society Publishers")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0